// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._fb2512x7 button{padding-inline:var(--ds-space-075,6px)}._1e0c1txw{display:flex}\n._1jiyidpf button{border-bottom-left-radius:0}\n._t1diidpf button{border-top-right-radius:0}\n._u6eridpf button{border-bottom-right-radius:0}\n._xk07idpf button{border-top-left-radius:0}", ""]);
// Exports
module.exports = exports;
